import { render } from "./Privacy.vue?vue&type=template&id=319cbffc&scoped=true"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"

import "./Privacy.vue?vue&type=style&index=0&id=319cbffc&scoped=true&lang=css"

import exportComponent from "D:\\projects\\RED MENACE\\redmenacegames.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319cbffc"]])

export default __exports__